"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const images_1 = require("../../../services/images");
const react_i18next_1 = require("react-i18next");
const SharedDetail = () => {
    const [t] = (0, react_i18next_1.useTranslation)("i18n");
    return ((0, jsx_runtime_1.jsxs)("div", { className: "detail", children: [(0, jsx_runtime_1.jsx)("img", { src: images_1.icons.DedicatedDetail, alt: "" }), (0, jsx_runtime_1.jsx)("span", { className: "text-detail", children: t("overview.shared") })] }));
};
exports.default = SharedDetail;
